import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import useStyles from './RightPanel.styles';

export const RightPanelComponent = ({ className, content }) => {
  const { container, marketingContent } = useStyles();
  return (
    <section className={classnames(container, className)}>
      <div className={marketingContent}>{content}</div>
    </section>
  );
};

RightPanelComponent.propTypes = {
  className: PropTypes.string,
  content: PropTypes.element,
  locale: PropTypes.shape({}).isRequired,
  theme: PropTypes.shape({}).isRequired
};

RightPanelComponent.defaultProps = {
  className: '',
  content: null
};

export default RightPanelComponent;
